import { render, staticRenderFns } from "./layout-header.vue?vue&type=template&id=5c502595&scoped=true&"
import script from "./layout-header.vue?vue&type=script&lang=js&"
export * from "./layout-header.vue?vue&type=script&lang=js&"
import style0 from "./layout-header.vue?vue&type=style&index=0&id=5c502595&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c502595",
  null
  
)

export default component.exports